import { useMutation } from "@tanstack/react-query";
import { getEnv } from "../../../../AppConfigs";
import api from "../../../../services/axiosBase";
import omit from "lodash/omit";

interface Variables {
  itemId: string;
  [key: string]: any;
}

const siteId = getEnv("REACT_APP_SP_SITE_ID");
const listId = getEnv("REACT_APP_FOLDER_AND_FILE_SP_LIST_ID");

const update = (variables: Variables) => {
  const url = `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${listId}/items/${variables.itemId}/fields`;
  const body = omit(variables, ["itemId"]);
  return api.patch(url, body, { headers: { "Content-Type": "application/json" } });
};

export const useUpdateDocDirectory = () => {
  return useMutation({
    mutationFn: (variables: Variables) => update(variables),
  });
};
